module.exports = __webpack_public_path__ + "img/3.dfa9205d.png";